import React from 'react';

const content = require('../../content/content')

const quizImg = require('../../images/presidentsQuiz.png')

class Quiz extends React.Component {
    render() {
        return(
            <section className="quiz">
                <h2 className="project-title">{ content.projects.quiz.title }</h2>
                <p className="project-links">
                    <a href={ content.projects.quiz.live } target="blank">Live</a>
                    <a href={ content.projects.quiz.repo } target="blank">Repo</a>
                </p>
                <img src={ quizImg } alt="Presidents Quiz App" />
                <p className="tech">
                    <span className="tech-item" >HTML5</span>
                    <span className="tech-item" >CSS3</span>
                    <span className="tech-item" >JavaScript</span>
                    <span className="tech-item" >jQuery</span>
                </p>
                <p className="project-description" >{ content.projects.quiz.desc }</p>
            </section>
        )
    }

}

export default Quiz